<template>
  <PackageManager
    :channel-type-id="CHANNEL_TYPE.SMS"
    :show-back="showBack"
    :is-open="isOpenSms"
    :translations="trans._packageManager.sms"
    @close="close"
  />
</template>

<script setup lang="ts">
import { CHANNEL_TYPE } from "vue-app/types/enums.ts";
import PackageManager from "vue-app/components/PackageManager/PackageManager.vue";
import { usePackageManager } from "vue-app/composables/usePackageManager";

interface Props {
  showBack?: boolean;
}
withDefaults(defineProps<Props>(), {
  showBack: false,
});

const { close, isOpenSms } = usePackageManager();
</script>
